import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Location } from '@angular/common';
import { AppPageService } from 'common';
import { NewFormFacade } from './new-form.facade';
import { AutosaveResponseData, FormDetailsComponentData } from '../../form-details.model';
import { SubmissionDetailsHandleSharedActionsService } from '../../../../actions/submission-details-handle-shared-actions.service';
import { SubmissionDetailsActionsService } from '../../../../actions/submission-details-actions.service';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { CanDeactivateSubmissionDetails } from '../../../../../../infrastructure/guards/can-deactivate-submission-details.guard';
import { FormDetailsActionsService } from '../../services/actions/form-details-actions.service';

@UntilDestroy()
@Component({
    selector: 'ifbp-new-form',
    templateUrl: './new-form.component.html',
    providers: [NewFormFacade],
    standalone: false
})
export class NewFormComponent implements OnInit, CanDeactivateSubmissionDetails {
  initialData: FormDetailsComponentData;

  constructor(
    private readonly facade: NewFormFacade,
    private readonly handleSharedActions: SubmissionDetailsHandleSharedActionsService,
    private readonly actions: SubmissionDetailsActionsService,
    private readonly formActionsService: FormDetailsActionsService,
    private readonly location: Location,
    private readonly appPageService: AppPageService,
  ) { }

  ngOnInit(): void {
    this.initData();
    this.initActions();
  }

  private initData(): void {
    this.facade.getComponentData$().pipe(untilDestroyed(this))
      .subscribe((data: FormDetailsComponentData) => {
        this.initialData = data;
        this.actions.updateSubmissionDetailsAppBarTitle({
          title: 'New Submission'
        });
      });
  }

  private initActions(): void {
    this.handleSharedActions.watchCommonActions().pipe(untilDestroyed(this)).subscribe();
    this.formActionsService.autosaveResponse$
      .pipe(filter(response => !!response?.params?.applicationId), take(1))
      .subscribe((data: AutosaveResponseData) => {
        this.location.replaceState(`/submission/${data.params.applicationId}`);
        this.appPageService.removeLastFromHistory("/submission/new");
      });
  }

  canDeactivate(): Observable<boolean> {
    this.actions.canDeactivateRequest();
    return this.actions.canDeactivate();
  }
}
